import { Trophy } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { MonthlyScoresTab } from '@/components/administration/scoring/monthly-scores-tab'
import { RankingTab } from '@/components/administration/scoring/ranking-tab'
import { RoleWeightsTab } from '@/components/administration/scoring/role-weights-tab'
import { AdminCardPage } from '@/components/commons'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { adminBackRoute } from '@/constants/admin-menu'
import { ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/store'

export const ScoringPage = () => {
	const navigate = useNavigate()
	const { t } = useTranslation()
	// protótipo do ranking: visível apenas para ADMIN por enquanto
	const isAdmin = useAuthStore((s) => s.user?.role) === 'ADMIN'

	return (
		<AdminCardPage
			icon={<Trophy className="size-5" />}
			title={t('administration.scoring.title')}
			subtitle={t('administration.scoring.subtitle')}
			onBack={() => navigate(adminBackRoute(ROUTES.ADMINISTRATION.SCORING))}
		>
			<Tabs defaultValue="monthly-scores">
				<TabsList className="w-fit">
					<TabsTrigger value="monthly-scores" className="flex-none">
						{t('administration.scoring.tabs.monthlyScores')}
					</TabsTrigger>
					<TabsTrigger value="role-weights" className="flex-none">
						{t('administration.scoring.tabs.roleWeights')}
					</TabsTrigger>
					{isAdmin && (
						<TabsTrigger value="ranking" className="flex-none">
							{t('administration.scoring.tabs.ranking')}
						</TabsTrigger>
					)}
				</TabsList>

				<TabsContent value="monthly-scores" className="pt-4">
					<MonthlyScoresTab />
				</TabsContent>

				<TabsContent value="role-weights" className="pt-4">
					<RoleWeightsTab />
				</TabsContent>

				{isAdmin && (
					<TabsContent value="ranking" className="pt-4">
						<RankingTab />
					</TabsContent>
				)}
			</Tabs>
		</AdminCardPage>
	)
}
